// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__29JbU","footer":"ModalError_footer__DjSdu"};